import { Component, OnInit, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import { Observable } from 'rxjs/Observable';

import { CceService } from './../../../services/cce.service';
import { Cce } from '../../../models/Cce';

@Component({
  selector: 'app-cce-search',
  templateUrl: './cce-search.component.html',
  styleUrls: ['./cce-search.component.css'],
  providers: [
    CceService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CceSearchComponent),
      multi: true
    }
  ]
})
export class CceSearchComponent  implements OnInit {
  stateCtrl: FormControl;
  public loading = false;

  items: Observable<any>;
  selected: Cce;
  descrizione: string;

  constructor(private service: CceService) {
    this.stateCtrl = new FormControl();
  }

  onOptionSelected(e) {
    console.log(e.option.value)
    this.selected = e.option.value;
    this.propagateChange( e.option.value);
  }

  onChange(e) {
    console.log('change', e)
  }

  ngOnInit() {
    this.stateCtrl.valueChanges
      .debounceTime(200)
      .subscribe(val => {
        let boo = (typeof (val) === 'string' || val instanceof String);
        if (boo) {
          this.loading = true;
          this.items = this.service.search(val)
            .map(result => {
              console.log(result)
              this.loading = false;
              this.selected = undefined;
              this.propagateChange(undefined);
              if (result.success) {
                return result.items;
              }
            })
        }
      })
  }

  displayFn(item) {
    return item ? item.descrizione : item;
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Cce) {
    console.log('======= ************ Cce writeValue', obj)
    this.descrizione = obj ? obj.descrizione : undefined;
    this.selected = obj;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/cce/cce-search/cce-search.component.ts